import { Loader } from '@deque/cauldron-react';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuthContext } from '~/common/contexts/auth';
import NotFound from '../pages/NotFound';

const InternalAdminProtected: React.FC<{ children: React.ReactNode }> = ({
  children
}) => {
  const { user, loading: authLoading } = useAuthContext();
  const { t } = useTranslation();
  const loaderRef = React.createRef<HTMLDivElement>();

  useEffect(() => {
    loaderRef.current?.focus();
  }, [loaderRef.current]);

  if (authLoading) {
    return <Loader label={t('Loading...')} ref={loaderRef} tabIndex={-1} />;
  }

  // Deny access unless the user belongs to either the 'helpdesk' or 'com.deque' groups
  // and is also a member of both the 'admin' and 'superadmin' groups in user.groups
  if (
    !user?.groups.includes('helpdesk') &&
    !user?.groups.includes('com.deque') &&
    (!user?.groups.includes('admin') || !user?.groups.includes('superadmin'))
  ) {
    return <NotFound />;
  }

  return <>{children}</>;
};

export default InternalAdminProtected;
